<template>
  <div>
    <md-table v-model="users.data" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Referencia">{{ item.id }}</md-table-cell>
        <md-table-cell md-label="Fecha y Hora">{{ item.fecha }} </md-table-cell>
        <md-table-cell md-label="Opciones"
          ><a href="#" v-on:click="Delete(item)"
            ><md-icon style="color: red">delete</md-icon
            ><md-tooltip md-direction="top">Eliminar</md-tooltip></a
          ></md-table-cell
        >
      </md-table-row>
    </md-table>
    <hr />
    <md-table>
      <md-table-row>
        <md-button class="md-warning" v-on:click="Anterior()"
          >Anterior</md-button
        >
        <md-button class="md-warning" disabled
          >{{ page }} de {{ pages }}</md-button
        >
        <md-button class="md-warning" v-on:click="Siguiente()"
          >Siguiente</md-button
        >
      </md-table-row>
    </md-table>

    <md-card
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      style="margin: 20px"
    >
      <md-card-content>
        <md-datepicker v-model="fecha">
          <label>Agregar fecha</label>
        </md-datepicker>
        <md-button class="md-button md-success" v-on:click="Add()">
          <md-icon>today</md-icon> Agregar
        </md-button>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import Global from "../../Global";

export default {
  name: "GestionarFecha",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selected: [],
      users: [],
      page: 1,
      pages: null,
      url: Global.url,
      fecha: null
    };
  },
  mounted() {
    this.getFechas();
  },
  methods: {
    getFechas() {
      axios
        .get(this.url + "fecha?page=" + this.page, {
          headers: { ApiToken: localStorage.usertoken }
        })
        .then(res => {
          this.users = res.data;
          this.pages = res.data.last_page;
        });
    },
    Siguiente() {
      if (this.page + 1 <= this.pages) {
        axios
          .get(this.users.next_page_url, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
            this.page = res.data.current_page;
          });
      }
    },
    Anterior() {
      if (this.page - 1 > 0) {
        axios
          .get(this.users.prev_page_url, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
            this.page = res.data.current_page;
          });
      }
    },
    Delete(item) {
      if (confirm("Seguro quieres eliminar fecha: " + item.fecha)) {
        axios
          .delete(this.url + "fecha/" + item.id, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(response => {
            if (response.status == 200) {
              axios
                .get(this.url + "fecha?page=" + this.page, {
                  headers: { ApiToken: localStorage.usertoken }
                })
                .then(res => {
                  this.users = res.data;
                  this.pages = res.data.last_page;
                });
            }
          });
      }
    },
    Add() {
      axios
        .get(
          this.url + "fecha/add/" + this.$moment(this.fecha).format("Y-MM-DD"),
          {
            headers: { ApiToken: localStorage.usertoken }
          }
        )
        .then(res => {
          this.getFechas();
        });
    }
  }
};
</script>
